<template lang="pug">
  div.data-null
    img(src="../assets/img/无数据.png")
    p 无数据
</template>

<script>
export default {
  name: 'DataNull'
}
</script>

<style lang="scss" scoped>
  .data-null{
    text-align: center;
    p{
      margin-top: 10px;
      color: #999;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/components/DataNull.vue